window.addEventListener('turbolinks:load', function() {
  let ga_code = document.body.dataset.gaCode

  if (ga_code && typeof ga === 'function') {
    ga('create', ga_code, 'auto', 'ownerTracker')
    ga('ownerTracker.send', 'pageview', window.location.pathname + window.location.search)
  }
})
